(function () {
    'use strict';

    function expandRow() {
        return {
            restrict: 'A',
            scope: {},
            link: function (scope, element, attrs) {
                element.on("mouseover", function () {
                    element.removeClass('truncated');
                    element.addClass('not-truncated');
                });
                element.on("mouseleave", function () {
                    element.removeClass('not-truncated');
                    element.addClass('truncated');
                });
            }
        };
    }

    expandRow.$inject = [];

    angular.module('ecap.common').directive('expandRow', expandRow);
})();
